import { API, API_POST } from "../../../Config";

export const handleAddRecipe = (payload) => {

  const f = new FormData();

  Array.from(payload.images).forEach((img, idx) => {
    f.append(`r_images[${idx}]`, img);
  });
  f.append("title", payload.title);
  f.append("description", payload.description);
  f.append("recipe_type", payload.recipe_type);

  return API_POST(API.AddRecipe, f);
};
